import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import axios from 'axios';
import { toast } from 'react-toastify';
import authService from './api-authorization/AuthorizeService';

const AdminPriceListSettingsData = (props: RouteComponentProps<{}>) => {
    const [loading, setLoading] = React.useState(true);
    const [errors, setErrors] = React.useState<{ [key: string]: string }>({});
    const [companyId, setCompanyId] = React.useState(3);
    const [travelExtraHoursRateTilt, setTravelExtraHoursRateTilt] = React.useState(0);
    const [travelExtraHoursRateCrane, setTravelExtraHoursRateCrane] = React.useState(0);
    const [travelRateWasteTank, setTravelRateWasteTank] = React.useState(0);
    const [travelSteps1to7, setTravelSteps1to7] = React.useState(0);
    const [travelSteps8to13, setTravelSteps8to13] = React.useState(0);
    const [travelSteps14, setTravelSteps14] = React.useState(0);
    const [cleaningFeeEWS, setCleaningFeeEWS] = React.useState(0);
    const [powerPoleTrenchBuilder, setPowerPoleTrenchBuilder] = React.useState(0);
    const [powerPoleTrenchSuperSafe, setPowerPoleTrenchSuperSafe] = React.useState(0);
    const [trolleyPrice, setTrolleyPrice] = React.useState(0);
    const [tempFenceTrolleyPrice, setTempFenceTrolleyPrice] = React.useState(0);
    const [crossoverSectionRate, setCrossoverSectionRate] = React.useState(0);
    const [adminFee, setAdminFee] = React.useState(0);
    const [travel50MinRate, setTravel50MinRate] = React.useState(0);
    const [travel100MinRate, setTravel100MinRate] = React.useState(0);
    const [travel150MinRate, setTravel150MinRate] = React.useState(0);
    const [truckLabourRate, setTruckLabourRate] = React.useState(0);
    const [fencePartPickupFee, setFencePartPickupFee] = React.useState(0);
    const [calloutFee, setCalloutFee] = React.useState(0);
    const [calloutFeeWeekend, setCalloutFeeWeekend] = React.useState(0);
    const [calloutFeeEmergency, setCalloutFeeEmergency] = React.useState(0);
    const [epaExtra30MinOnSiteFee, setEpaExtra30MinOnSiteFee] = React.useState(0);
    const [epaTruckHireHourlyRate, setEpaTruckHireHourlyRate] = React.useState(0);
    const [epaConfinedSpaceRate, setEpaConfinedSpaceRate] = React.useState(0);
    const [epaWasteSampleTestingAmount, setEpaWasteSampleTestingAmount] = React.useState(0);
    const [epaDomesticGreaseTrapAmount, setEpaDomesticGreaseTrapAmount] = React.useState(0);
    const [chargeFuelSurcharge, setChargeFuelSurcharge] = React.useState(false);
    const [fuelSurcharge, setFuelSurcharge] = React.useState(0);
    const [fuelSurchargePC, setFuelSurchargePC] = React.useState(0);
    const [readOnly, setReadOnly] = React.useState(false);

    React.useEffect(() => {
        window.scrollTo(0, 0);

        getData();
    }, []);

    const getData = async () => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        axios.get('api/User/CheckUserPermission?Permission=AdminPricelistsView&SubId=' + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data == true) {
                getPricelistSettingsData();
            } else if (res.data == false) {
                //redirect to 403 permission denied
                props.history.push("/accessdenied")
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    const getPricelistSettingsData = async () => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        axios.get('api/PriceList/GetPricelistSettingsItems?SubId=' + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            setTravelExtraHoursRateTilt(res.data.travelExtraHoursRateTilt);
            setTravelExtraHoursRateCrane(res.data.travelExtraHoursRateCrane);
            setTravelRateWasteTank(res.data.travelRateWasteTank);
            setTravelSteps1to7(res.data.travelSteps1To7);
            setTravelSteps8to13(res.data.travelSteps8To13);
            setTravelSteps14(res.data.travelSteps14);
            setCleaningFeeEWS(res.data.cleaningFeeEWS);
            setPowerPoleTrenchBuilder(res.data.powerPoleTrenchBuilder);
            setPowerPoleTrenchSuperSafe(res.data.powerPoleTrenchSuperSafe);
            setTrolleyPrice(res.data.trolleyPrice);
            setTempFenceTrolleyPrice(res.data.tempFenceTrolleyPrice);
            setCrossoverSectionRate(res.data.crossoverSectionRate);
            setAdminFee(res.data.adminFee);
            setTravel50MinRate(res.data.travel50MinRate);
            setTravel100MinRate(res.data.travel100MinRate);
            setTravel150MinRate(res.data.travel150MinRate);
            setTruckLabourRate(res.data.truckLabourRate);
            setFencePartPickupFee(res.data.fencePartPickupFee);
            setCalloutFee(res.data.calloutFee);
            setCalloutFeeWeekend(res.data.calloutFeeWeekend);
            setCalloutFeeEmergency(res.data.calloutFeeEmergency);
            setEpaExtra30MinOnSiteFee(res.data.epaExtra30MinOnSiteFee);
            setEpaTruckHireHourlyRate(res.data.epaTruckHireHourlyRate);
            setEpaConfinedSpaceRate(res.data.epaConfinedSpaceRate);
            setEpaWasteSampleTestingAmount(res.data.epaWasteSampleTestingAmount);
            setEpaDomesticGreaseTrapAmount(res.data.epaDomesticGreaseTrapAmount);
            setChargeFuelSurcharge(res.data.chargeFuelSurcharge);
            setFuelSurcharge(res.data.fuelSurcharge);
            setFuelSurchargePC(res.data.fuelSurchargePumpClean);
            setCompanyId(res.data.companyId);
            setReadOnly(res.data.readOnly);
            setLoading(false);
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    const clearError = (errorItem: string) => {
        let errorList = errors;
        delete errorList[errorItem];

        setErrors(errorList);
    }

    const validate = () => {
        let errorsList: any = {};
        let formIsValid = true;

        if (companyId === 3) {
            if (travelExtraHoursRateTilt <= 0) {
                errorsList["travelExtraHoursRateTilt"] = "Travel Tilt Extra Hours Rate is Required";
                formIsValid = false;
            }

            if (travelExtraHoursRateCrane <= 0) {
                errorsList["travelExtraHoursRateCrane"] = "Travel Crane Extra Hours Rate is Required";
                formIsValid = false;
            }

            if (travelRateWasteTank <= 0) {
                errorsList["travelRateWasteTank"] = "Travel Waste Tank Rate is Required";
                formIsValid = false;
            }

            if (travelSteps1to7 <= 0) {
                errorsList["travelSteps1to7"] = "Steps 1-7 Travel is Required";
                formIsValid = false;
            }

            if (travelSteps8to13 <= 0) {
                errorsList["travelSteps8to13"] = "Steps 8-13 Travel is Required";
                formIsValid = false;
            }

            if (travelSteps14 <= 0) {
                errorsList["travelSteps14"] = "Steps 14+ Travel is Required";
                formIsValid = false;
            }

            if (cleaningFeeEWS <= 0) {
                errorsList["cleaningFeeEWS"] = "Cleaning Fees EWS is Required";
                formIsValid = false;
            }

            if (powerPoleTrenchBuilder <= 0) {
                errorsList["powerPoleTrenchBuilder"] = "Power Pole Trench by Builder Price is Required";
                formIsValid = false;
            }

            if (powerPoleTrenchSuperSafe <= 0) {
                errorsList["powerPoleTrenchSuperSafe"] = "Power Pole Trench by SS Price is Required";
                formIsValid = false;
            }

            if (trolleyPrice <= 0) {
                errorsList["trolleyPrice"] = "Trolley Price is Required";
                formIsValid = false;
            }

            if (tempFenceTrolleyPrice <= 0) {
                errorsList["tempFenceTrolleyPrice"] = "1300 Trolley Price is Required";
                formIsValid = false;
            }

            if (crossoverSectionRate <= 0) {
                errorsList["crossoverSectionRate"] = "Crossover Section Rate is Required";
                formIsValid = false;
            }

            if (fencePartPickupFee <= 0) {
                errorsList["fencePartPickupFee"] = "Fence Part Pickup Fee is Required";
                formIsValid = false;
            }

            if (epaExtra30MinOnSiteFee <= 0) {
                errorsList["epaExtra30MinOnSiteFee"] = "EPA Extra 30mins On Site Fee is Required";
                formIsValid = false;
            }

            if (epaTruckHireHourlyRate <= 0) {
                errorsList["epaTruckHireHourlyRate"] = "EPA Truck Hire Hourly Rate is Required";
                formIsValid = false;
            }

            if (epaConfinedSpaceRate <= 0) {
                errorsList["epaConfinedSpaceRate"] = "EPA Confined Space Rate is Required";
                formIsValid = false;
            }

            if (epaWasteSampleTestingAmount <= 0) {
                errorsList["epaWasteSampleTestingAmount"] = "EPA Waste Sample Testing Fee is Required";
                formIsValid = false;
            }

            if (epaDomesticGreaseTrapAmount <= 0) {
                errorsList["epaDomesticGreaseTrapAmount"] = "EPA Domestic Grease Trap Price is Required";
                formIsValid = false;
            }

            if (calloutFee <= 0) {
                errorsList["calloutFee"] = "Callout Fee is Required";
                formIsValid = false;
            }

            if (calloutFeeWeekend <= 0) {
                errorsList["calloutFeeWeekend"] = "Callout Fee Weekend is Required";
                formIsValid = false;
            }

            if (calloutFeeEmergency <= 0) {
                errorsList["calloutFeeEmergency"] = "Callout Fee Emergency/Same Day is Required";
                formIsValid = false;
            }

            if (fuelSurcharge <= 0) { 
                errorsList["fuelSurcharge"] = "Fuel Surcharge is Required";
                formIsValid = false;
            }

            if (fuelSurchargePC <= 0) {
                errorsList["fuelSurchargePC"] = "Fuel Surcharge P&C is Required";
                formIsValid = false;
            }

            if (adminFee <= 0) {
                errorsList["adminFee"] = "Admin Fee is Required";
                formIsValid = false;
            }
        } else {
            if (travel50MinRate <= 0) {
                errorsList["travel50MinRate"] = "Travel 50 min Rate is Required";
                formIsValid = false;
            }
            if (travel100MinRate <= 0) {
                errorsList["travel100MinRate"] = "Travel 100 min Rate is Required";
                formIsValid = false;
            }
            if (travel150MinRate <= 0) {
                errorsList["travel150MinRate"] = "Travel 150 min Rate is Required";
                formIsValid = false;
            }
            if (truckLabourRate <= 0) {
                errorsList["truckLabourRate"] = "Truck Labour Rate is Required";
                formIsValid = false;
            }
        }

        setErrors(errorsList);
        return formIsValid;
    }

    const submit = (e: any) => {
        e.preventDefault();

        if (validate()) {
            if (companyId === 3) {
                savePricelistSettingsDunny();
            } else {
                savePricelistSettingsScaffold();
            }
        } else {
            toast.error("Please fix validation errors before Saving")
        }
    }

    const savePricelistSettingsDunny = async () => {
        const token = await authService.getAccessToken();

        var savePriceListSettings = {
            travelExtraHoursRateTilt: travelExtraHoursRateTilt,
            travelExtraHoursRateCrane: travelExtraHoursRateCrane,
            travelRateWasteTank: travelRateWasteTank,
            travelSteps1to7: travelSteps1to7,
            travelSteps8to13: travelSteps8to13,
            travelSteps14: travelSteps14,
            cleaningFeeEWS: cleaningFeeEWS,
            powerPoleTrenchBuilder: powerPoleTrenchBuilder,
            powerPoleTrenchSuperSafe: powerPoleTrenchSuperSafe,
            trolleyPrice: trolleyPrice,
            tempFenceTrolleyPrice: tempFenceTrolleyPrice,
            crossoverSectionRate: crossoverSectionRate,
            fencePartPickupFee: fencePartPickupFee,
            calloutFee: calloutFee,
            calloutFeeWeekend: calloutFeeWeekend,
            calloutFeeEmergency: calloutFeeEmergency,
            epaExtra30MinOnSiteFee: epaExtra30MinOnSiteFee,
            epaTruckHireHourlyRate: epaTruckHireHourlyRate,
            epaConfinedSpaceRate: epaConfinedSpaceRate,
            epaWasteSampleTestingAmount: epaWasteSampleTestingAmount,
            epaDomesticGreaseTrapAmount: epaDomesticGreaseTrapAmount,
            chargeFuelSurcharge: chargeFuelSurcharge,
            fuelSurcharge: fuelSurcharge,
            fuelSurchargePumpClean: fuelSurchargePC,
            adminFee: adminFee
        };

        axios.post('api/PriceList/SavePricelistSettingsDunny', savePriceListSettings, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data.isError) {
                var errors = res.data.messages as any[];
                for (var i = 0; i < errors.length; i++) {
                    toast.error(errors[i].content);
                };
            } else {
                toast.success("Price List Settings Saved Successfully");
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    const savePricelistSettingsScaffold = async () => {
        const token = await authService.getAccessToken();

        var savePriceListSettings = {
            travel50MinRate: travel50MinRate,
            travel100MinRate: travel100MinRate,
            travel150MinRate: travel150MinRate,
            truckLabourRate: truckLabourRate
        };

        axios.post('api/PriceList/savePricelistSettingsScaffold', savePriceListSettings, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data.isError) {
                var errors = res.data.messages as any[];
                for (var i = 0; i < errors.length; i++) {
                    toast.error(errors[i].content);
                };
            } else {
                toast.success("Price List Settings Saved Successfully");
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    const renderDetails = (
        <form onSubmit={submit}>
            <div className="makeitred">Note: Prices are INCLUDING GST</div>
            <div className={companyId === 3 ? "" : "hidden"}>
                <div className="makeitred marginTop10">Travel Formula for Tilt / Crane / Waste Tank: [Travel Rate] * [3 hours (min)] * 2 (return)</div>
                <label className="input-group" htmlFor="travelExtraHoursRateTilt">
                    <span className="label label-large">Travel Tilt Extra Hours Rate</span>
                    <input type='number' min="0" step="0.01" id="travelExtraHoursRateTilt" name="travelExtraHoursRateTilt" className='form-control input--small textalignright' value={travelExtraHoursRateTilt} onChange={(e) => { clearError(e.target.name); setTravelExtraHoursRateTilt(Number(e.target.value)) }} />
                </label>
                <span className="label errors marginLeftLabelLarge">{errors["travelExtraHoursRateTilt"]}</span>

                <label className="input-group" htmlFor="travelExtraHoursRateCrane">
                    <span className="label label-large">Travel Crane Extra Hours Rate</span>
                    <input type='number' min="0" step="0.01" id="travelExtraHoursRateCrane" name="travelExtraHoursRateCrane" className='form-control input--small textalignright' value={travelExtraHoursRateCrane} onChange={(e) => { clearError(e.target.name); setTravelExtraHoursRateCrane(Number(e.target.value)) }} />
                </label>
                <span className="label errors marginLeftLabelLarge">{errors["travelExtraHoursRateCrane"]}</span>

                <label className="input-group" htmlFor="travelRateWasteTank">
                    <span className="label label-large">Travel Waste Tank Rate</span>
                    <input type='number' min="0" step="0.01" id="travelRateWasteTank" name="travelRateWasteTank" className='form-control input--small textalignright' value={travelRateWasteTank} onChange={(e) => { clearError(e.target.name); setTravelRateWasteTank(Number(e.target.value)) }} />
                </label>
                <span className="label errors marginLeftLabelLarge">{errors["travelRateWasteTank"]}</span>

                <label className="input-group" htmlFor="travelSteps1to7">
                    <span className="label label-large">Event Steps 1-7 Travel Amt</span>
                    <input type='number' min="0" step="0.01" id="travelSteps1to7" name="travelSteps1to7" className='form-control input--small textalignright' value={travelSteps1to7} onChange={(e) => { clearError(e.target.name); setTravelSteps1to7(Number(e.target.value)) }} />
                </label>
                <span className="label errors marginLeftLabelLarge">{errors["travelSteps1to7"]}</span>

                <label className="input-group" htmlFor="travelSteps8to13">
                    <span className="label label-large">Event Steps 8-13 Travel Amt</span>
                    <input type='number' min="0" step="0.01" id="travelSteps8to13" name="travelSteps8to13" className='form-control input--small textalignright' value={travelSteps8to13} onChange={(e) => { clearError(e.target.name); setTravelSteps8to13(Number(e.target.value)) }} />
                </label>
                <span className="label errors marginLeftLabelLarge">{errors["travelSteps8to13"]}</span>

                <label className="input-group" htmlFor="travelSteps14">
                    <span className="label label-large">Event Steps 14+ Travel Amt</span>
                    <input type='number' min="0" step="0.01" id="travelSteps14" name="travelSteps14" className='form-control input--small textalignright' value={travelSteps14} onChange={(e) => { clearError(e.target.name); setTravelSteps14(Number(e.target.value)) }} />
                </label>
                <span className="label errors marginLeftLabelLarge">{errors["travelSteps14"]}</span>

                <label className="input-group" htmlFor="cleaningFeeEWS">
                    <span className="label label-large">Cleaning Fees EWS / Toilet Blocks</span>
                    <input type='number' min="0" step="1" id="cleaningFeeEWS" name="cleaningFeeEWS" className='form-control input--small textalignright' value={cleaningFeeEWS} onChange={(e) => { clearError(e.target.name); setCleaningFeeEWS(Number(e.target.value)) }} />
                </label>
                <span className="label errors marginLeftLabelLarge">{errors["cleaningFeeEWS"]}</span>

                <label className="input-group" htmlFor="powerPoleTrenchBuilder">
                    <span className="label label-large">Power Pole Trench by Builder (per meter) Price</span>
                    <input type='number' min="0" step="1" id="powerPoleTrenchBuilder" name="powerPoleTrenchBuilder" className='form-control input--small textalignright' value={powerPoleTrenchBuilder} onChange={(e) => { clearError(e.target.name); setPowerPoleTrenchBuilder(Number(e.target.value)) }} />
                </label>
                <span className="label errors marginLeftLabelLarge">{errors["powerPoleTrenchBuilder"]}</span>

                <label className="input-group" htmlFor="powerPoleTrenchSuperSafe">
                    <span className="label label-large">Power Pole Trench by SS (per meter) Price</span>
                    <input type='number' min="0" step="1" id="powerPoleTrenchSuperSafe" name="powerPoleTrenchSuperSafe" className='form-control input--small textalignright' value={powerPoleTrenchSuperSafe} onChange={(e) => { clearError(e.target.name); setPowerPoleTrenchSuperSafe(Number(e.target.value)) }} />
                </label>
                <span className="label errors marginLeftLabelLarge">{errors["powerPoleTrenchSuperSafe"]}</span>

                <label className="input-group" htmlFor="trolleyPrice">
                    <span className="label label-large">Trolley Price</span>
                    <input type='number' min="0" step="1" id="trolleyPrice" name="trolleyPrice" className='form-control input--small textalignright' value={trolleyPrice} onChange={(e) => { clearError(e.target.name); setTrolleyPrice(Number(e.target.value)) }} />
                </label>
                <span className="label errors marginLeftLabelLarge">{errors["trolleyPrice"]}</span>

                <label className="input-group" htmlFor="tempFenceTrolleyPrice">
                    <span className="label label-large">1300 Trolley Price</span>
                    <input type='number' min="0" step="1" id="tempFenceTrolleyPrice" name="tempFenceTrolleyPrice" className='form-control input--small textalignright' value={tempFenceTrolleyPrice} onChange={(e) => { clearError(e.target.name); setTempFenceTrolleyPrice(Number(e.target.value)) }} />
                </label>
                <span className="label errors marginLeftLabelLarge">{errors["tempFenceTrolleyPrice"]}</span>

                <label className="input-group" htmlFor="crossoverSectionRate">
                    <span className="label label-large">Crossover Section Rate</span>
                    <input type='number' min="0" step="0.01" id="crossoverSectionRate" name="crossoverSectionRate" className='form-control input--small textalignright' value={crossoverSectionRate} onChange={(e) => { clearError(e.target.name); setCrossoverSectionRate(Number(e.target.value)) }} />
                </label>
                <span className="label errors marginLeftLabelLarge">{errors["crossoverSectionRate"]}</span>

                <label className="input-group" htmlFor="fencePartPickupFee">
                    <span className="label label-large">Fence Part Pickup Fee</span>
                    <input type='number' min="0" step="0.01" id="fencePartPickupFee" name="fencePartPickupFee" className='form-control input--small textalignright' value={fencePartPickupFee} onChange={(e) => { clearError(e.target.name); setFencePartPickupFee(Number(e.target.value)) }} />
                </label>
                <span className="label errors marginLeftLabelLarge">{errors["fencePartPickupFee"]}</span>

                <label className="input-group" htmlFor="epaExtra30MinOnSiteFee">
                    <span className="label label-large">EPA Extra 30 min Onsite Fee</span>
                    <input type='number' min="0" step="0.01" id="epaExtra30MinOnSiteFee" name="epaExtra30MinOnSiteFee" className='form-control input--small textalignright' value={epaExtra30MinOnSiteFee} onChange={(e) => { clearError(e.target.name); setEpaExtra30MinOnSiteFee(Number(e.target.value)) }} />
                </label>
                <span className="label errors marginLeftLabelLarge">{errors["epaExtra30MinOnSiteFee"]}</span>

                <label className="input-group" htmlFor="epaTruckHireHourlyRate">
                    <span className="label label-large">EPA Truck Hire Hourly Rate</span>
                    <input type='number' min="0" step="0.01" id="epaTruckHireHourlyRate" name="epaTruckHireHourlyRate" className='form-control input--small textalignright' value={epaTruckHireHourlyRate} onChange={(e) => { clearError(e.target.name); setEpaTruckHireHourlyRate(Number(e.target.value)) }} />
                </label>
                <span className="label errors marginLeftLabelLarge">{errors["epaTruckHireHourlyRate"]}</span>

                <label className="input-group" htmlFor="epaConfinedSpaceRate">
                    <span className="label label-large">EPA Confined Space (4 Hrs) Rate</span>
                    <input type='number' min="0" step="0.01" id="epaConfinedSpaceRate" name="epaConfinedSpaceRate" className='form-control input--small textalignright' value={epaConfinedSpaceRate} onChange={(e) => { clearError(e.target.name); setEpaConfinedSpaceRate(Number(e.target.value)) }} />
                </label>
                <span className="label errors marginLeftLabelLarge">{errors["epaConfinedSpaceRate"]}</span>

                <label className="input-group" htmlFor="epaWasteSampleTestingAmount">
                    <span className="label label-large">EPA Waste Sample Testing Fee</span>
                    <input type='number' min="0" step="0.01" id="epaWasteSampleTestingAmount" name="epaWasteSampleTestingAmount" className='form-control input--small textalignright' value={epaWasteSampleTestingAmount} onChange={(e) => { clearError(e.target.name); setEpaWasteSampleTestingAmount(Number(e.target.value)) }} />
                </label>
                <span className="label errors marginLeftLabelLarge">{errors["epaWasteSampleTestingAmount"]}</span>

                <label className="input-group" htmlFor="epaDomesticGreaseTrapAmount">
                    <span className="label label-large">EPA Domestic Grease Trap Fee</span>
                    <input type='number' min="0" step="0.01" id="epaDomesticGreaseTrapAmount" name="epaDomesticGreaseTrapAmount" className='form-control input--small textalignright' value={epaDomesticGreaseTrapAmount} onChange={(e) => { clearError(e.target.name); setEpaDomesticGreaseTrapAmount(Number(e.target.value)) }} />
                </label>
                <span className="label errors marginLeftLabelLarge">{errors["epaDomesticGreaseTrapAmount"]}</span>

                <label className="input-group" htmlFor="calloutFee">
                    <span className="label label-large">Callout Fee</span>
                    <input type='number' min="0" step="0.01" id="calloutFee" name="calloutFee" className='form-control input--small textalignright' value={calloutFee} onChange={(e) => { clearError(e.target.name); setCalloutFee(Number(e.target.value)) }} />
                </label>
                <span className="label errors marginLeftLabelLarge">{errors["calloutFee"]}</span>

                <label className="input-group" htmlFor="calloutFeeWeekend">
                    <span className="label label-large">Callout Fee Weekend</span>
                    <input type='number' min="0" step="0.01" id="calloutFeeWeekend" name="calloutFeeWeekend" className='form-control input--small textalignright' value={calloutFeeWeekend} onChange={(e) => { clearError(e.target.name); setCalloutFeeWeekend(Number(e.target.value)) }} />
                </label>
                <span className="label errors marginLeftLabelLarge">{errors["calloutFeeWeekend"]}</span>

                <label className="input-group" htmlFor="calloutFeeEmergency">
                    <span className="label label-large">Callout Fee Emergency/Same Day</span>
                    <input type='number' min="0" step="0.01" id="calloutFeeEmergency" name="calloutFeeEmergency" className='form-control input--small textalignright' value={calloutFeeEmergency} onChange={(e) => { clearError(e.target.name); setCalloutFeeEmergency(Number(e.target.value)) }} />
                </label>
                <span className="label errors marginLeftLabelLarge">{errors["calloutFeeEmergency"]}</span>

                <label className="input-group" htmlFor="chargeFuelSurcharge">
                    <span className="label label-large">Charge Fuel Surcharge</span>
                    <input className="checkbox" type="checkbox" id="chargeFuelSurcharge" name="chargeFuelSurcharge" checked={chargeFuelSurcharge} onChange={(e) => { clearError(e.target.name); setChargeFuelSurcharge(!chargeFuelSurcharge) }}></input>
                </label>

                <label className="input-group" htmlFor="fuelSurcharge">
                    <span className="label label-large">Fuel Surcharge</span>
                    <input type='number' min="0" step="0.01" id="fuelSurcharge" name="fuelSurcharge" className='form-control input--small textalignright' value={fuelSurcharge} onChange={(e) => { clearError(e.target.name); setFuelSurcharge(Number(e.target.value)) }} />
                </label>
                <span className="label errors marginLeftLabelLarge">{errors["fuelSurcharge"]}</span>

                <label className="input-group" htmlFor="fuelSurchargePC">
                    <span className="label label-large">Fuel Surcharge P&C</span>
                    <input type='number' min="0" step="0.01" id="fuelSurchargePC" name="fuelSurchargePC" className='form-control input--small textalignright' value={fuelSurchargePC} onChange={(e) => { clearError(e.target.name); setFuelSurchargePC(Number(e.target.value)) }} />
                </label>
                <span className="label errors marginLeftLabelLarge">{errors["fuelSurchargePC"]}</span>

                <label className="input-group" htmlFor="adminFee">
                    <span className="label label-large">Admin Fee</span>
                    <input type='number' min="0" step="0.01" id="adminFee" name="adminFee" className='form-control input--small textalignright' value={adminFee} onChange={(e) => { clearError(e.target.name); setAdminFee(Number(e.target.value)) }} />
                </label>
                <span className="label errors marginLeftLabelLarge">{errors["adminFee"]}</span>
            </div>
            <div className={companyId === 3 ? "hidden" : ""}>
                <label className="input-group" htmlFor="travel50MinRate">
                    <span className="label label-large">Travel 50 Min Rate</span>
                    <input type='number' min="0" step="0.01" id="travel50MinRate" name="travel50MinRate" className='form-control input--small textalignright' value={travel50MinRate} onChange={(e) => { clearError(e.target.name); setTravel50MinRate(Number(e.target.value)) }} />
                </label>
                <span className="label errors marginLeftLabelLarge">{errors["travel50MinRate"]}</span>

                <label className="input-group" htmlFor="travel100MinRate">
                    <span className="label label-large">Travel 100 Min Rate</span>
                    <input type='number' min="0" step="0.01" id="travel100MinRate" name="travel100MinRate" className='form-control input--small textalignright' value={travel100MinRate} onChange={(e) => { clearError(e.target.name); setTravel100MinRate(Number(e.target.value)) }} />
                </label>
                <span className="label errors marginLeftLabelLarge">{errors["travel100MinRate"]}</span>

                <label className="input-group" htmlFor="travel150MinRate">
                    <span className="label label-large">Travel over 100 min Rate</span>
                    <input type='number' min="0" step="0.01" id="travel150MinRate" name="travel150MinRate" className='form-control input--small textalignright' value={travel150MinRate} onChange={(e) => { clearError(e.target.name); setTravel150MinRate(Number(e.target.value)) }} />
                </label>
                <span className="label errors marginLeftLabelLarge">{errors["travel150MinRate"]}</span>

                <label className="input-group" htmlFor="truckLabourRate">
                    <span className="label label-large">3 Person Truck Labour Rate</span>
                    <input type='number' min="0" step="0.01" id="truckLabourRate" name="truckLabourRate" className='form-control input--small textalignright' value={truckLabourRate} onChange={(e) => { clearError(e.target.name); setTruckLabourRate(Number(e.target.value)) }} />
                </label>
                <span className="label errors marginLeftLabelLarge">{errors["truckLabourRate"]}</span>
            </div>

            <div className="marginBottom10">
                <button className={readOnly ? "hidden" : "defaultbutton defaultbutton__large"} type="submit">Save</button>
            </div>
        </form>
    )

    let contents = loading
        ? <p><em>Loading...</em></p>
        : renderDetails;

    return (
        <div>
            <h1>Price Lists Settings</h1>
            {contents}
        </div>
    );

}

export default AdminPriceListSettingsData;